/**
 * Card Brand Enum
 */
export enum ImgBrandEnum {
  visa = "/assets/images/card_visa.svg",
  masterCard = "/assets/images/card_master.svg",
  amex = "/assets/images/card_amex.png",
  diners = "/assets/images/card_diners.png",
  alia = "/assets/images/card_aliam.png",
  discover = "/assets/images/discover-logo.png",
  jcb = "/assets/images/card_jcb.png",
  pci = "/assets/images/pci-dss.png",
  carnet = "/assets/images/card_carnet.svg",
}



// WEBPACK FOOTER //
// ./src/containers/Card/store/ImgBrandEnum.ts